// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ScheduleColumn[data-v-6ad80cf3]{width:300px}.dragMeColumn[data-v-6ad80cf3]{cursor:move}", ""]);
// Exports
module.exports = exports;
